import { render, staticRenderFns } from "./labelsBrandSerial.vue?vue&type=template&id=06907f29&"
import script from "./labelsBrandSerial.vue?vue&type=script&lang=js&"
export * from "./labelsBrandSerial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports